import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GdsIss0101Actions, { GdsIss0101Types } from '../Stores/GdsIss0101/Actions';

const getAppStore = state => state.app;

export function* gdsIss0101FetchGdsIss0101({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(GdsIss0101Actions.gdsIss0101FetchGdsIss0101Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsIss/indexProcess/GDS_ISS_01_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        GdsIss0101Actions.gdsIss0101FetchGdsIss0101Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsIss0101Actions.gdsIss0101FetchGdsIss0101Loading(false));
  }
}

export function* gdsIss0101PrintGdsIss0101({ hdrIds }) {
  try {
    yield put(GdsIss0101Actions.gdsIss0101PrintGdsIss0101Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `gdsIss/printProcess/GDS_ISS_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      const selectedDocuments = hdrIds.map(d => ({ id: d }));

      FileSaver.saveAs(result.data, 'WhseJob.pdf');
      yield put(GdsIss0101Actions.gdsIss0101RemoveSelectedDocuments(selectedDocuments));
      yield put(GdsIss0101Actions.gdsIss0101ResetTimestamp());
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsIss0101Actions.gdsIss0101PrintGdsIss0101Loading(false));
  }
}

export function* gdsIss0101GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/gdsIssDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(GdsIss0101Types.GDS_ISS0101_GO_TO_DOCUMENT, gdsIss0101GoToDocument),
  takeLatest(GdsIss0101Types.GDS_ISS0101_FETCH_GDS_ISS0101, gdsIss0101FetchGdsIss0101),
  takeLatest(GdsIss0101Types.GDS_ISS0101_PRINT_GDS_ISS0101, gdsIss0101PrintGdsIss0101)
];
